import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import debugFn from 'debug';
import { useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useVersionCheck } from './useVersionCheck';

const debug = debugFn('useForceUpdateOldVersion');

const IDLE_TIME_MS = 3 * 60 * 60 * 1000; // 3 hours

/**
 * When the user is inactive for 1 hour and a new app version is available,
 * refreshes the page automatically so they get the update without manual action.
 */
export const useForceUpdateOldVersion = () => {
  const { isNewVersionAvailable } = useVersionCheck();
  const capture = usePostHogCapture();
  const isNewVersionAvailableRef = useRef(isNewVersionAvailable);
  const captureRef = useRef(capture);

  useEffect(() => {
    isNewVersionAvailableRef.current = isNewVersionAvailable;
  }, [isNewVersionAvailable]);

  useEffect(() => {
    captureRef.current = capture;
  }, [capture]);

  useIdleTimer({
    timeout: IDLE_TIME_MS,
    onIdle: () => {
      if (isNewVersionAvailableRef.current) {
        debug(
          'forcing reload because new version is available and user has been idle for %d ms',
          IDLE_TIME_MS,
        );
        captureRef.current('new_version_reload_forced');
        window.location.reload();
      }
    },
  });
};
